import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import "./GlobalPrivacyControlPopupStyles.scss";
import { cx } from "@emotion/css";
import { useEffect, useState } from "react";
import { dnbGetCookie, dnbSetCookie, gpcpCookieName, isNotUndefinedOrNull } from "../FunctionsCore";
import { renderIdentifierGeneric } from "../RenderIdentifier";
const GlobalPrivacyControlPopupComponent = (properties) => {
    const { gpcPopupCopy } = properties;
    const GPCP_COOKIE_EXPIRE_DAYS = 365;
    if (!isNotUndefinedOrNull(gpcPopupCopy) || gpcPopupCopy.length === 0) {
        throw new Error();
    }
    const [showPopup, setShowPopup] = useState(false);
    useEffect(() => {
        window.setTimeout(() => {
            setShowPopup(true);
            dnbSetCookie(gpcpCookieName, "1", GPCP_COOKIE_EXPIRE_DAYS);
        }, 3000);
    }, []);
    return (_jsx("div", Object.assign({ className: cx("globalPrivacyControlPopupWrapper", showPopup ? "active" : void 0) }, { children: _jsx("div", Object.assign({ className: "gpc-popup" }, { children: _jsx("div", Object.assign({ className: "box" }, { children: _jsxs("div", Object.assign({ className: "gpc-overlay" }, { children: [_jsx("div", { children: _jsx("button", { "aria-label": "Close", className: cx("close", "button"), onClick: () => setShowPopup(false), type: "button" }) }), _jsx("div", { children: isNotUndefinedOrNull(gpcPopupCopy) ?
                                (_jsx("div", { className: "gpc-description", dangerouslySetInnerHTML: { "__html": gpcPopupCopy } })) :
                                (_jsx(_Fragment, {})) })] })) })) })) })));
};
const globalPrivacyControlPopup = (renderableData) => {
    // Enable Global Privacy Control popup based on GPC signal, user location (California) and "gpcp" cookie
    if (isNotUndefinedOrNull(renderableData.data.enableGpcPopup) && dnbGetCookie(gpcpCookieName) !== "1") {
        // @ts-expect-error Ignore
        const globalPrivacyControlIsTrue = window.navigator.globalPrivacyControl === true;
        if (globalPrivacyControlIsTrue) {
            renderIdentifierGeneric(GlobalPrivacyControlPopupComponent, renderableData);
        }
    }
};
export { globalPrivacyControlPopup };
